import { InitializationRoutingModule } from './initialization-routing.module';
import { GdInputsModule } from '../../inputs/fields/gd-inputs-module';
import { GdPipesModule } from '../../pipes/gd-pipes-module';
import { CmnTemplatesModule } from '../../templates/cmn-templates-module';

import { StartComponent } from './start.component';
import { InitializationComponent } from "./initialization.component";

import {CommonModule, DecimalPipe} from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbdSortableHeader } from './sortable.directive';


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		InitializationRoutingModule,
		CmnTemplatesModule,
		GdInputsModule,
        GdPipesModule
	],
	declarations: [
        InitializationComponent, 		//pages start
		StartComponent,
		NgbdSortableHeader
	],
	exports: [
        InitializationComponent, 	//pages start
		StartComponent
	],
	providers: [
		DecimalPipe
	]
})
export class InitializationModule { }
